<template>
  <div class="col-12 content-inner" v-loading="DOWNLOADING_PRESCRIPTION" :element-loading-text="$t('message.Getting your prescription')">
    <div v-if="historicPrescriptions">
      <div class="row" style="height: 85vh;">
        <div class="col-12 col-lg-3" style="height: 100%;">
          <!-- List for extra small devices -->
          <div class="row d-block d-md-block d-lg-none" style="height: 100%; overflow: auto;">
            <div class="col-12 prescription-list" v-for="prescription in historicPrescriptions" :key="prescription._id">
              <div @click="viewPrescription(prescription)">
                <div class="col-12">
                  <div class="row">
                    <div class="col-2 col-md-1 col-lg-3">
                      <i class="el-icon-tickets prescription-icon"></i>
                    </div>
                    <div class="col-10 col-md-11 col-lg-9">
                      <p class="card-heading reason">
                        {{ prescription.reason }}
                      </p>
                      <p class="card-heading mb-0">
                        {{ $t("message.Dr") }}.
                        {{ prescription.provider.firstName }}
                        {{ prescription.provider.lastName }}
                      </p>
                      <p class="card-heading">
                        {{
                          getFormattedDate(prescription.created)
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <infinite-loading spinner="waveDots" @infinite="getHistoricPrescriptions">
              <span slot="no-more"><i class="fa fa-info-circle"></i> {{ $t("message.No more prescritptions") }}</span>
              <span slot="no-results"> <i class="fa fa-info-circle"></i>
                {{ $t("message.No Prescriptions available") }}</span>
            </infinite-loading>
          </div>
          <!-- List for all other bigger deviecs -->
          <div class="row d-none d-md-none d-lg-block" style="height: 100%;overflow: auto;">
            <div :class="'col-12 prescription-list ' +
              ((prescription.prescriptions[0] && prescription.prescriptions[0].appointmentId) == (selectedPrescription && selectedPrescription.prescriptions[0] && selectedPrescription.prescriptions[0].appointmentId) ? 'selected' : '')
            " v-for="prescription in historicPrescriptions" :key="prescription._id">
              <!-- <div @click="viewPrescription(prescription)"> -->
              <div @click="selectPrescription(prescription)">
                <div class="col-12">
                  <div class="row">
                    <div class="col-2 col-md-1 col-lg-3">
                      <i class="el-icon-tickets prescription-icon"></i>
                    </div>
                    <div class="col-10 col-md-11 col-lg-9">
                      <p class="card-heading reason">
                        {{ prescription.reason }}
                      </p>
                      <p class="card-heading mb-0">
                        {{ $t("message.Dr") }}.
                        {{ prescription.provider.firstName }}
                        {{ prescription.provider.lastName }}
                      </p>
                      <p class="card-heading">
                        {{
                          getFormattedDate(prescription.created)
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <infinite-loading spinner="waveDots" @infinite="getHistoricPrescriptions">
              <span slot="no-more"><i class="fa fa-info-circle"></i> {{ $t("message.No more prescritptions") }}</span>
              <span slot="no-results"> <i class="fa fa-info-circle"></i>
                {{ $t("message.No Prescriptions available") }}</span>
            </infinite-loading>
          </div>
        </div>
        <div class="col-9 d-none d-lg-block" v-if="selectedPrescription" style="height: 100%;width:100%;overflow: auto;">
          <card style="margin-top: 2.2em;">
            <prescription v-if="selectedPrescription && selectedPrescription.prescriptions[0] && selectedPrescription.prescriptions[0].prescriptions" :prescription="selectedPrescription.prescriptions[0].prescriptions" :appointment="selectedPrescription" :editable="false"></prescription>
            <n-button type="primary" round style="margin-left: 15px" @click.native="downloadPrescription()" v-if="HAS_PRESCRIPTION">
              <i class="fa fa-print"></i>
              {{ $t("message.Download Prescription") }}
            </n-button>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrescriptionService from "../../../services/prescription";
export default {
  name: "NotesHistory",

  components: {},

  data() {
    return {
      historicPrescriptions: [],
      DOWNLOADING_PRESCRIPTION: false,
      selectedPrescription: false,
      appointment: {},
      historicPrescriptionsPagiantion: {
        pageNumber: 1,
        pageSize: 10,
        pageSize: 3,
        totalPages: 0,
      },
    };
  },

  computed: {
    patient() {
      return this.$store.state.patient;
    },
    HAS_PRESCRIPTION() {
      let prescriptions =
        this.selectedPrescription.prescriptions[0].prescriptions;
      return PrescriptionService.hasPrescription(prescriptions);
    },
  },

  methods: {
    selectPrescription(prescription) {
      this.selectedPrescription = prescription;
    },
    async viewPrescription(prescription) {
      let appointment = await this.$store.dispatch(
        "getAppointment",
        prescription.prescriptions[0].appointmentId
      );
      this.$store.commit("setState", {
        stateName: "appointment",
        stateValue: appointment,
      });
      // route to prescription page
      this.$router.push(
        "/viewhistoricprescription/" + prescription.prescriptions[0]._id
      );
    },
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },
    async getHistoricPrescriptions($state) {
      try {
        let response = await this.$store.dispatch("getPrescriptionsHistory", {
          patientId: this.patient.patientId,
          pagination: this.historicPrescriptionsPagiantion,
        });

        if (response.data && response.data.length) {
          this.historicPrescriptions.push(...response.data);
          this.historicPrescriptionsPagiantion.totalPages = response.totalPages;
          this.historicPrescriptionsPagiantion.pageNumber += 1;
          $state && $state.loaded();
          if (this.historicPrescriptions && this.historicPrescriptions.length) {
            this.selectedPrescription = this.historicPrescriptions[0];
          }
        } else {
          $state && $state.complete();
        }
      } catch (e) {
        console.log(e);
      }
    },
    async downloadPrescription() {
      console.log(this.selectedPrescription);
      let that = this;
      this.appointment = await this.$store.dispatch(
        "getAppointment",
        this.selectedPrescription.prescriptions[0].appointmentId
      );
      that.DOWNLOADING_PRESCRIPTION = true;
      let prescriptionDate = null;
      if (this.selectedPrescription.prescriptions[0].created) {
        prescriptionDate = this.selectedPrescription.prescriptions[0].created;
      }
      if (window.cordova) {
        PrescriptionService.getDataURL(
          this.appointment,
          this.selectedPrescription.prescriptions[0].prescriptions,
          prescriptionDate,
          {},
          (dataUrl) => {
            // convert base64 to raw binary data held in a string
            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            var byteString = atob(dataUrl.split(",")[1]);

            // separate out the mime component
            var mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];

            // write the bytes of the string to an ArrayBuffer
            var ab = new ArrayBuffer(byteString.length);

            // create a view into the buffer
            var ia = new Uint8Array(ab);

            // set the bytes of the buffer to the correct values
            for (var i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }

            // write the ArrayBuffer to a blob, and you're done
            var pdfBlob = new Blob([ab], { type: mimeString });

            let storageLocation = "";

            if (typeof device !== "undefined") {
              switch (device.platform) {
                case "Android":
                  storageLocation = cordova.file.externalDataDirectory;
                  break;

                case "iOS":
                  storageLocation = cordova.file.documentsDirectory;
                  break;
              }

              let folderPath = storageLocation;

              window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                  dir.getFile(
                    "prescription",
                    {
                      create: true,
                    },
                    function (file) {
                      file.createWriter(
                        function (fileWriter) {
                          fileWriter.write(pdfBlob);

                          fileWriter.onwriteend = function () {
                            var url = file.nativeURL;
                            cordova.plugins.fileOpener2.open(
                              url,
                              pdfBlob.type,
                              {
                                error: function error(err) {
                                  console.error(err);
                                  that.DOWNLOADING_PRESCRIPTION = false;
                                  alert(this.$t("message.Unable to download"));
                                },
                                success: function success() {
                                  that.DOWNLOADING_PRESCRIPTION = false;
                                  console.log("success with opening the file");
                                },
                              }
                            );
                          };

                          fileWriter.onerror = function (err) {
                            that.DOWNLOADING_PRESCRIPTION = false;
                            alert(this.$t("message.Unable to download"));
                            console.error(err);
                          };
                        },
                        function (err) {
                          that.DOWNLOADING_PRESCRIPTION = false;
                          // failed
                          alert(this.$t("message.Unable to download"));
                          console.error(err);
                        }
                      );
                    },
                    function (err) {
                      that.DOWNLOADING_PRESCRIPTION = false;
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  that.DOWNLOADING_PRESCRIPTION = false;
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            }
          }
        );
      } else {
        PrescriptionService.download(
          this.appointment,
          this.selectedPrescription.prescriptions[0].prescriptions,
          prescriptionDate,
          {},
          () => {
            that.DOWNLOADING_PRESCRIPTION = false;
          }
        );
      }
    },
  },
};
</script>

<style scoped>
.prescription-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.prescription-list:first-child {
  border-top: none;
}

.prescription-list.selected {
  background-color: whitesmoke;
}

.prescription-icon {
  line-height: 3em;
  color: var(--color-primary);
  font-size: 1.5em;
}

.reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}
</style>
